import { modals } from './modal/init-modals';
const initAddToCart = () => {
  const buttons = document.querySelectorAll('[data-add-to-cart]');

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      const card = button.closest('[data-product-card]');

      if (!card) {
        return;
      }

      const productId = card.dataset.productId;
      const quantityInput = card.querySelector('[data-quantity-input]');
      const quantity = Number(quantityInput?.value) || 1;

      const body = new URLSearchParams({
        product_id: productId,
        quantity: quantity.toString(),
      });

      button.disabled = true;

      try {
        const response = await fetch(wooSettings.addToCartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          credentials: 'same-origin',
          body,
        });

        const result = await response.json();

        if (result.error) {
          console.error('Не удалось добавить товар в корзину', result);
          return;
        }
        if (result.fragments) {
          Object.entries(result.fragments).forEach(([selector, html]) => {
            document.querySelectorAll(selector).forEach((element) => {
              element.outerHTML = html;
            });
          });
        }
        modals.open('cart-add')
        setTimeout(() => {
          if (document.querySelector('[data-modal="cart-add"].is-active')) {
            modals.close('cart-add');
          }
        }, 3000);

      } catch (error) {
        console.error('Ошибка добавления товара в корзину', error);
      } finally {
        button.disabled = false;
      }
    });
  });
};

export {initAddToCart};